<lazy-echart class="chart" [class.chart--fixed-height]="hasFixedHeight"
    [options]="chartOptions"
    (chartClick)="chartClicked($event)"
></lazy-echart>
